<script>
	import Icon from '$lib/Components/Layout/Icon/Icon.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	const content = [
		{
			group: 'General Window Insert Info',
			items: [
				{
					title: 'Window Compatibility',
					description:
						'Discover if your windows are the right fit for Indow inserts.',
					href: '/guides/indow-window-compatibility',
				},
				{
					title: 'How Inserts Work',
					description:
						'Why are Indow inserts so effective at blocking drafts, noise, and more? Learn more!',
					href: '/how-to/insulate-your-home',
				},
				{
					title: 'How To Order',
					description:
						'Our inserts are custom-made to your windows. Learn how to get started.',
					href: '/about-indow/how-to-order',
				},
				{
					title: 'How To Measure',
					description:
						'We provide step-by-step resources to help you get production quality measurements. ',
					href: '/self-measure-instructions',
				},
				{
					title: 'How To Install',
					description:
						'Indow inserts slide right into your existing windows without modifications to your window frames.',
					href: '/how-to/install-window-inserts',
				},
				{
					title: 'FAQ',
					description:
						'Anything we missed? Find answers here or get in touch with us!',
					href: '/resources/faq',
				},
			],
		},
		{
			group: 'Guarantees & Warranties',
			items: [
				{
					title: 'Residential Warranty',
					description:
						'Your Indow insert purchase is protected from defect for the life of your home. ',
					href: '/warranties/residential-lifetime-warranty',
				},
				{
					title: 'Commercial Warranty',
					description:
						'Our commercial inserts are backed by our 10 year warranty.',
					href: '/warranties/commercial-warranty',
				},
				{
					title: 'Snug Fit Guarantee',
					description:
						'Your Indow inserts are guaranteed to fit perfectly upon receipt.',
					href: '/warranties/snug-fit-guarantee',
				},
				{
					title: 'Noise Disclaimer',
					description:
						'Understand how noise enters your space and what level of noise reduction you can expect.',
					href: '/noise-disclaimer',
				},
				{
					title: 'Expedited Production',
					description:
						'Learn how to get your Indow inserts faster when you need results ASAP.',
					href: '/warranties/expedited-production',
				},
				{
					title: 'Quiet Comfort Guarantee',
					description:
						'Rest easy knowing your acoustic Indow inserts will reduce noise coming through your windows.',
					href: '/warranties/quiet-comfort-guarantee',
				},
			],
		},
		{
			group: 'Useful Guides',
			items: [
				{
					title: 'Choose The Right Solution',
					description:
						'Compare the benefits, performance, and costs of storm windows vs replacement windows.',
					href: '/resources/storm-windows-guide/replacement',
				},
				{
					title: 'Increase Resale Value',
					description:
						'Indow inserts are a cost-effective way to improve the resale value of a noisy or drafty home.',
					href: '/how-to/increase-home-resale-value',
				},
				{
					title: 'Improve Energy Score',
					description:
						"Indow inserts are a great way to improve your home's energy efficiency score.",
					href: '/how-to/improve-home-energy-score',
				},
				{
					title: 'Soundproof Your Home',
					description:
						'Indow inserts are the most effective tool in reducing noise pollution in your home.',
					href: '/how-to/soundproof-your-home',
				},
				{
					title: 'Preserve Historic windows',
					description:
						'Retain the charm of your original, historic windows by insulating with Indow inserts.',
					href: '/solutions/preserve-historic-windows',
				},
				{
					title: 'More Tips & Guides',
					description:
						'Find more handy guides on how to insulate your space and achieve comfort & quiet.',
					href: '/resources/featured-articles',
				},
			],
		},
	];
</script>

<Section>
	<h1 class="text-left">How To Insulate With Indow Inserts</h1>
	<p class="text-left">
		Achieving a well-insulated home with Indow inserts is straightforward. Our
		comprehensive guides provide everything you need to know to enhance your
		home's comfort and energy savings.
	</p>

	{#each content as { group, items }, i1 (i1)}
		<h2 class="mb-1 text-left text-base uppercase">{group}</h2>
		<hr />
		<ul
			class="
     mb-8 grid list-none grid-cols-1
     md:grid-cols-2
   "
		>
			{#each items as { title, href, description }, i2 (i2)}
				<li
					class="
       mb-6
       md:m-0
     "
				>
					<a
						class="
        block rounded-md p-0 no-underline transition-all
        md:p-4
        md:hover:bg-gray-100
      "
						{href}
					>
						<h3
							class="
         mb-1 flex gap-2 text-left text-lg/5.5 font-semibold text-balance
         text-indow-grey-dark normal-case
       "
						>
							{title}

							<Icon name="arrow" class="h-5.5 w-4 text-indow-blue" />
						</h3>
						<p
							class="
         text-left leading-5 font-normal text-balance text-indow-grey-dark
         normal-case
       "
						>
							{description}
						</p>
					</a>
				</li>
			{/each}
		</ul>
	{/each}
</Section>
<GetAFreeEstimate />
